exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detect-steps[data-v-394dbd5e]{display:flex;justify-content:center;flex-direction:column}.detect-steps-link[data-v-394dbd5e]{width:0;height:64px;margin-left:5px;margin-top:6px;margin-bottom:6px;border-left:1px dashed #d1d7e1}", ""]);

// exports
